<template>
  <div>
    <b-container>
      <div class="row pt-3">
        <div class="col">
          <img src="./../../../assets/web/img/logo-pgj.png" alt="large" />
        </div>
        <div class="col d-none d-sm-block">
          <a href="#" style="padding-top:12px;" class="float-right">
            <i class="fa fa-user" aria-hidden="true"></i>&nbsp;
            <span>免费注册</span>
          </a>
        </div>
      </div>
    </b-container>

    <b-container
      fluid
      class="my-3 bg-light"
      style="border-bottom: 1px solid #eee; border-top: 1px solid #eee; "
    >
      <div class="container">
        <div class="row">
          <div class="py-3 pl-3 text-muted">
            <i class="fa fa-th" aria-hidden="true"></i>&nbsp;
			如发票无法正常显示，
			可&nbsp;<b-link v-on:click="handleDownload">下载后查看</b-link>
			，也可以进入&nbsp;<b-link v-on:click="handleHtml">数据展示</b-link>
          </div>
        </div>
        <div class="row pb-3">
          <div class="col-lg-9">
            <div class="card border-0 p-0">
              <div class="card-body p-0">
                <div
                  id="invoiceFrameContainer"
                  class="panel-body"
                  style="height: 610px;"
                >
                  <div id="print_data">
                    <!-- <div style="height:600px,width:837" v-html="doc.html"></div> -->

                    <iframe
                      id="invoiceFrame"
                      style="min-height: 610px;"
                      width="100%"
                      frameborder="0"
                      :src="htmlUrl"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 d-none d-lg-block">
            <div class="card card-default shadow-sm">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-9">
                    <h6>入账</h6>
                    <small class="text-muted">显示入账详情</small>
                  </div>
                  <div class="col-md-3 center-block">
                    <i
                      class="fa fa-flag fa-2x pt-2 text-danger"
                      aria-hidden="true"
                      v-if="invoice.accStatus=='0'"
                    ></i>
                    <i
                      class="fa fa-flag fa-2x pt-2 text-success"
                      aria-hidden="true"
                      v-if="invoice.accStatus=='1'"
                    ></i>
                  </div>
                </div>
                <hr />
                <div id="favorite-content-popup" class="row">
                  <ul class="col-md-12 list-unstyled">
                    <div v-if="invoice.accStatus=='1'">
                      <li>
                        <small>时间：{{invoice.accTime}}</small>
                      </li>
                      <li>
                        <small>财务：{{invoice.accUserName}}</small>
                      </li>
                      <li>
                        <small>单位：{{invoice.accEntName}}</small>
                      </li>
                      <!-- <br /> -->
                      <!-- <p class="text-center text-success" style="font-size: 30px;">已记账</p> -->
                    </div>
                    <div v-if="invoice.accStatus=='0'">
                      <p class="text-center text-danger" style="font-size: 30px;">未入账</p>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
            <div class="card card-button shadow-sm inv-download mt-3" style="cursor: pointer;" v-show="invoice.fileFormat!=null">
              <div class="card-body" @click="handleDownload()">
                <div class="row">
                  <div class="col-md-9">
                    <h6>下载</h6>
                    <small class="text-muted">下载版式文件到本地</small>
                  </div>
                  <div class="col-md-3">
                    <i
                      class="fa fa-download fa-2x pt-2"
                      aria-hidden="true"
                      style="color: rgb(221, 221, 221); "
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import * as invoiceFacade from "../../../api/invoice-facade.js";

export default {
  // validations:
  data() {
    return {
      invoiceId: "",
      invoice: {},

      htmlUrl: "",
      downloadUrl: ""
    };
  },
  watch: {},
  created() {
    // 异步加载列表数据
    // 异步加载检索条件中的“纳税人”下拉菜单
  },
  mounted() {
    let id = this.$route.query.c;
    this.invoiceId = id;
    this.handleQuery();


    // this.htmlUrl = process.env.VUE_APP_INVOICE_HTML_PREFIX + id;
    this.downloadUrl = process.env.VUE_APP_INVOICE_DOWNLOAD_PREFIX + id;
    //this.handleHtml();

  },
  methods: {
    // 执行查询操作
    async handleQuery() {
      this.pageLoading = true;
      invoiceFacade
        .obtain(this.invoiceId)
        .then(res => {
          this.invoice = res;
          // 构造iframe的页面内容
          console.log(res.fileFormat)
          let viewerUrl;
          if(res.fileFormat == "OFD"){
            viewerUrl = "./ofd/index.html?file=";
            this.htmlUrl = viewerUrl + encodeURIComponent(this.downloadUrl);
          }else if(res.fileFormat == "PDF"){
            viewerUrl = "./pdf/web/viewer.html?file=";
            this.htmlUrl = viewerUrl + encodeURIComponent(this.downloadUrl);
          }else if(res.fileFormat == null){
            this.htmlUrl = process.env.VUE_APP_INVOICE_HTML_PREFIX + this.invoiceId;
          }else{
            viewerUrl = "./#/imageViewer?file=";
            this.htmlUrl = viewerUrl + encodeURIComponent(this.downloadUrl);
          }
          // 更改iframe的高度
          // this.setIframeHeight()

          this.pageLoading = false;

        })
        .catch(err => {
          this.pageLoading = false;
          console.log("err", err);
        });
    },
    //下载
  handleDownload() {
    window.open(this.downloadUrl, "_blank");
    // this.setIframeHeight()
  },
	handleHtml(){
		// let id = this.$route.query.c;
    this.htmlUrl = process.env.VUE_APP_INVOICE_HTML_PREFIX + this.invoiceId;
    document.getElementById("invoiceFrame").contentWindow.location.reload(true);
	},
	setIframeHeight() {
		var iframe = document.getElementById("invoiceFrame");
		if (iframe) {
			var iframeWin = iframe.contentWindow || iframe.contentDocument.parentWindow;
			if (iframeWin.document.body) {
				var dheight = iframeWin.document.getElementById("content").clientHeight + 150;
				console.log(dheight);
				iframe.height = dheight
			}
		}
	},
    reinitIframe(){
	var iframe = document.getElementById("invoiceFrame");
	try{
		var bHeight = iframe.contentWindow.document.body.scrollHeight;
		var dHeight = iframe.contentWindow.document.documentElement.scrollHeight;
		var height = Math.min(bHeight, dHeight);
		iframe.height = height;
		// console.log(iframe.contentWindow);
		console.log(bHeight,dHeight);
	}catch (ex){
		console.log(ex.message)
	}
	}

  }
};
</script>

<style >
.time-collected-width {
  min-width: 120px;
}
.actions {
  width: 150px;
}
.blank {
  width: 150px;
}
.vs__dropdown-toggle {
  height: 33.5px;
}
</style>
